export const schedules = [
  { time: "04:30AM", name: "Mangala Arati" },
  { time: "07:15AM", name: "Shringar Arati" },
  { time: "07:30AM", name: "Guru Puja" },
  { time: "08:00AM", name: "Bhagavatam" },
  { time: "08:30AM", name: "Pushpa Aarti" },
  { time: "12:30PM", name: "Raj Bhoga Aarti" },
  { time: "01:00PM", name: "Temple Closes" },
  { time: "04:15PM", name: "Utthapan Aarti" },
  { time: "07:00PM", name: "Sandhaya Aarti" },
  { time: "08:15PM", name: "Shayan Aarti" },
  { time: "08:30PM", name: "Temple Closes" },
];

export const contactInfos = [
  {
    icon: "envelope",
    text: "mailto:iskconinfovvn@gmail.com",
  },
  {
    icon: "phone",
    text: "tel:+919998407654",
  },
  {
    icon: "phone",
    text: "tel:02692 230796",
  },
  {
    icon: "map-marker-alt",
    text: "map:Iskcon Road, Opp.B&B Polytechnic College, Mota Bazar, VV Nagar, Anand, Gujarat",
    link: "https://goo.gl/maps/GgdBcgof6EsLNCQs5",
  },
];

export const googleMapsLink =
  "https://www.google.com/maps?q=ISKCON+Vallabh+Vidyanagar";

export const emailLink = "mailto:iskconinfovvn@gmail.com";
